import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Expenses from "./pages/Expenses";
import Collaborators from "./pages/Collaborators";
import Timecards from "./pages/Timecards";
import Reports from "./pages/Reports";
import AccessManagement from "./pages/AccessManagement";
import Gestores from "./pages/Gestores";
import Profile from "./pages/Profile";
import Impersonate from "./pages/Impersonate";
import Avisos from "./pages/Avisos";
import { hasFeature, firstRoute } from "./lib/perms";

const FullLoader = () => (
    <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
);

const Protected = ({ children, feature }) => {
    const { user, loading } = useAuth();
    if (loading || user === null) return <FullLoader />;
    if (!user) return <Navigate to="/login" replace />;
    if (feature && !hasFeature(user, feature)) {
        return <Navigate to={firstRoute(user)} replace />;
    }
    return <Layout>{children}</Layout>;
};

const AppRoutes = () => {
    const location = useLocation();
    // Process OAuth callback synchronously during render (prevents race conditions).
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected feature="painel"><Dashboard /></Protected>} />
            <Route path="/extrato" element={<Protected feature="extrato"><Expenses /></Protected>} />
            <Route path="/colaboradores" element={<Protected feature="colaboradores"><Collaborators /></Protected>} />
            <Route path="/ponto" element={<Protected feature="ponto"><Timecards /></Protected>} />
            <Route path="/relatorios" element={<Protected feature="relatorios"><Reports /></Protected>} />
            <Route path="/acessos" element={<Protected feature="gestao_acessos"><AccessManagement /></Protected>} />
            <Route path="/gestores" element={<Protected feature="gestores"><Gestores /></Protected>} />
            <Route path="/perfil" element={<Protected><Profile /></Protected>} />
            <Route path="/avisos" element={<Protected><Avisos /></Protected>} />
            <Route path="/acessar-como" element={<Impersonate />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRoutes />
                    <Toaster position="top-right" richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
